import { c as _c } from "react/compiler-runtime";
import { Navigate, Routes, Route } from 'react-router-dom';
import { Homepage } from './pages/Homepage';
import { HelpPage } from './pages/HelpPage';
import { MeasurePage } from './pages/MeasuresPage';
import { AnalyzeTouchWeightPage } from './pages/analyze/AnalyzeTouchWeightPage';
import { AnalyzeFrontWeightPage } from './pages/analyze/AnalyzeFrontWeightPage';
import { AnalyzeStrikeWeightPage } from './pages/analyze/AnalyzeStrikeWeightPage';
import { AnalyzeWippenSupportSpringPage } from './pages/analyze/AnalyzeWippenSupportSpringPage';
import { AnalyzeStrikeWeightRatioPage } from './pages/analyze/AnalyzeStrikeWeightRatioPage';
import { DesignWippenSupportSpringsPage } from './pages/design/DesignWippenSupportSpringsPage';
import { DesignFrontWeightPage } from './pages/design/DesignFrontWeightPage';
import { DesignStrikeWeightPage } from './pages/design/DesignStrikeWeightPage';
import { DesignStrikeWeightRatioPage } from './pages/design/DesignStrikeWeightRatioPage';
import { DesignTouchWeightPreviewPage } from './pages/design/DesignTouchWeightPreviewPage';
import { DesignAdjustmentSheetPage } from './pages/design/DesignAdjustmentSheetPage';
import { AnalyzeDataSheetPage } from './pages/analyze/AnalyzeDatasheetPage';
import { PianoPage } from './pages/PianoPage';
export const AppRouter = () => {
  const $ = _c(17);
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Route path="/" Component={Homepage} />;
    t1 = <Route path="/analyze/data-sheet" Component={AnalyzeDataSheetPage} />;
    t2 = <Route path="/analyze/front-weight" Component={AnalyzeFrontWeightPage} />;
    t3 = <Route path="/analyze/touch-weight" Component={AnalyzeTouchWeightPage} />;
    t4 = <Route path="/analyze/strike-weight" Component={AnalyzeStrikeWeightPage} />;
    t5 = <Route path="/analyze/strike-weight-ratio" Component={AnalyzeStrikeWeightRatioPage} />;
    t6 = <Route path="/analyze/wippen-support-springs" Component={AnalyzeWippenSupportSpringPage} />;
    t7 = <Route path="/design/wippen-support-springs" Component={DesignWippenSupportSpringsPage} />;
    t8 = <Route path="/design/front-weight" Component={DesignFrontWeightPage} />;
    t9 = <Route path="/design/strike-weight" Component={DesignStrikeWeightPage} />;
    t10 = <Route path="/design/strike-weight-ratio" Component={DesignStrikeWeightRatioPage} />;
    t11 = <Route path="/design/touch-weight-preview" Component={DesignTouchWeightPreviewPage} />;
    t12 = <Route path="/design/adjustment-sheet" Component={DesignAdjustmentSheetPage} />;
    t13 = <Route path="/help" Component={HelpPage} />;
    t14 = <Route path="/measure" Component={MeasurePage} />;
    t15 = <Route path="/piano" Component={PianoPage} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t15;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t13 = $[5];
    t14 = $[6];
    t15 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Routes>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}<Route path="*" element={<Navigate to="/" replace={true} />} /></Routes>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  return t16;
};